import styled from "styled-components"
import device from "@utils/device"

export const Container = styled.div`
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  font-family: 'Trajan Pro 3';

    padding: 0 24px;
  @media ${device.tablet} {
  }
`

export const Title = styled.h2`
  font-family: 'Trajan Pro 3';
  margin: 120px 0 30px 0;

  font-size: 1.5rem;
  font-weight: 200;
  text-transform: uppercase;
  color: #fff;
`

export const SocialIcon = styled.a`
  display: inline-block;
  margin: 0 16px;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.2);
  }
`
